import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../contexts/AuthContext.js';

const UserList = ({ setActiveComponent, setSelectedUser, selectedUser }) => {
    const [users, setUsers] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const [selectedDM, setSelectedDM] = useState(false)
    const { AuthData, updateAuthData, setUser } = useAuthContext();

    useEffect(() => {
        // const token = sessionStorage.getItem("flaskAccessToken");
        const token = AuthData?.flaskAccessToken || sessionStorage.getItem("flaskAccessToken");
        // console.log("UserList token:", token)
        if (!token) return;

        fetch("http://localhost:5000/users", {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(res => res.json())
            .then(data => {
                // console.log("使用者清單:", data);
                setCurrentUser(data.current_user);
                setUsers(data.users);
                setUser(data.current_user)
            })
            .catch(err => {
                console.error("取得使用者失敗:", err);
            });
    }, [AuthData.flaskAccessToken]);

    const handleItClick = () => {
        setSelectedDM(!selectedDM);
    }

    const handleUserClick = (user) => {
        setSelectedUser(user)
        setActiveComponent('PrivateChat')
    }

    // useEffect(() => {
    //     console.log(selectedUser)
    // }, [selectedUser])

    return (
        <>
            <div className="menu-item" onClick={() => handleItClick()}
            >
                <img
                    src="./arrow02.png"
                    className={`arrow ${selectedDM ? "rotated" : ""}`}
                    alt="arrow"
                // onClick={handleClick}
                />
                    <img src='./DM.png' style={{ width: "18%" }}></img>
                    <div>DM</div>
            </div>
            <div className='item-option-container'>
                {/* {selectedDM && (<>
                    <div className={`item-option ${selectedUser === "1" ? "selected-option" : ""}`}
                        onClick={() => handleUserClick("1")}>1</div>
                    <div className='item-option'>2</div>
                </>)} */}
                <>
                    {selectedDM && users && users
                        .filter((user) => user.user_id !== currentUser.user_id)
                        .map((user) => (
                            <div className={`item-option ${selectedUser === user ? "selected-option" : ""}`}
                                onClick={() => handleUserClick(user)} key={user.user_id}>
                                {user.user_name || user.user_email}
                            </div>
                        ))}

                    {/* {selectedDM && users.users.map((user) => (
                        <li onClick={() => handleUserClick(user)}
                            key={user.user_id}>
                            {user.user_name || user.user_email}
                        </li>
                    ))} */}
                </>
            </div>
        </>
    );
};

export default UserList;
